import { ModuleFE_BaseApi } from '@nu-art/thunderstorm-frontend';
import { DBDef_InstallationFlowsheetConfiguration } from '@app/org-shared';
import { ThunderDispatcherV3 } from '@nu-art/thunderstorm-frontend/core/db-api-gen/types';
export const dispatch_onInstallationFlowsheetConfigurationsUpdated = new ThunderDispatcherV3('__onInstallationFlowsheetConfigurationsUpdated');
export class ModuleFE_InstallationFlowsheetConfiguration_Class extends ModuleFE_BaseApi {
    _v1;
    constructor() {
        super(DBDef_InstallationFlowsheetConfiguration, dispatch_onInstallationFlowsheetConfigurationsUpdated);
        this._v1 = {};
    }
}
export const ModuleFE_InstallationFlowsheetConfiguration = new ModuleFE_InstallationFlowsheetConfiguration_Class();
//# sourceMappingURL=ModuleFE_InstallationFlowsheetConfiguration.js.map